var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AuthBasedGuard } from './auth-based-guard';
var CanActivateLogin = /** @class */ (function (_super) {
    __extends(CanActivateLogin, _super);
    function CanActivateLogin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Check if the user is not logged to authorize the route (login route for example)
     * @returns {boolean}
     */
    CanActivateLogin.prototype.canActivate = function () {
        if (!this.isLogged) {
            return true;
        }
        else {
            // noinspection JSIgnoredPromiseFromCall
            this.router.navigate(['']);
            return false;
        }
    };
    return CanActivateLogin;
}(AuthBasedGuard));
export { CanActivateLogin };



// WEBPACK FOOTER //
// ./src/app/routing/login-guard.ts.pre-build-optimizer.js